import { RouteObject } from 'react-router-dom';
import Companies from '../Companies';
import NewCompany from '../pages/NewCompany/NewCompany';
import EditCompany from '../pages/EditCompany/EditCompany';

export const CompaniesRoutes: RouteObject[] = [
  {
    path: 'companies',
    element: <Companies />,
  },
  {
    path: 'companies/:id/edit',
    element: <EditCompany />,
  },
  {
    path: 'companies/new',
    element: <NewCompany />,
  },
];
